import { createAction, handleActions } from 'redux-actions';
import { useService } from '@piwikpro/platform';
import { Dispatch } from 'redux';

export const checkMetaSitePermissionsInitialized = createAction(
  '@platform/query/metaSitePermissions/list/init',
);
export const checkMetaSitePermissionsSucceeded = createAction<any, any>(
  '@platform/query/metaSitePermissions/list/success',
  payload => payload,
);
export const checkMetaSitePermissionsFailed = createAction(
  '@platform/query/metaSitePermissions/list/failed',
);

/* eslint-disable-next-line */
export const checkMetaSitePermissions = (id: string, userRole: string) => async (dispatch: Dispatch) => {
  const httpClient = useService('HttpCrate.httpClient');
  const config = useService('config');

  dispatch(checkMetaSitePermissionsInitialized());

  if (userRole === 'OWNER') {
    return dispatch(checkMetaSitePermissionsSucceeded({
      attributes: {
        actions: [
          'view',
          'edit',
          'view_details',
          'edit_details',
          'list_apps_in_meta_site',
          'manage',
        ],
      },
    }));
  }

  try {
    const resp = await httpClient.request({
      endpoint: `${config.get('ACCESS_CONTROL_URL')}/entry/${id}`,
      method: 'GET',
    }).jsonApi().send();
    dispatch(checkMetaSitePermissionsSucceeded(resp.data));
  } catch (err) {
    dispatch(checkMetaSitePermissionsFailed());

    throw err;
  }
};

const initialState = {
  levels: [],
  isLoading: true,
};

const reducer = handleActions({
  [checkMetaSitePermissionsInitialized as any]: () => initialState,
  [checkMetaSitePermissionsSucceeded as any]: (state, { payload }: any) => ({
    ...state,
    isLoading: false,
    levels: payload.attributes.actions,
  }),
  [checkMetaSitePermissionsFailed as any]: () => ({
    ...initialState,
    isLoading: false,
  }),
}, initialState);

export default reducer;
